import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import TopTenIntStockOptionsFull from './top-ten-int-stock-options-full';

const TopTenIntStockOptionsFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <TopTenIntStockOptionsFull {...props} />
    </QueryClientProvider>
  );
};

export { TopTenIntStockOptionsFullWidget }
